import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';

import { theme } from '../../assets/styles';
import { InputProps } from '../types'

const Theme = theme as { [key: string]: any };

type ErrorMessageProps = {
    component: React.ElementType;
};

type LabelProps = {
    component: React.ElementType;
    invalid?: boolean;
};

type InputStyleProps = Pick<InputProps, 'disabled' | 'invalid'>

export const InputWrapper = styled("div")`
  position: relative;
  width: fit-content;
  .delete{
    position: absolute;
    right: 10px;
    bottom: 27px;
    cursor: pointer;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const Label = styled(FormLabel)<LabelProps>`
  color: ${({disabled,invalid}) => (disabled && `${Theme.darkGray}`) || (invalid && `${Theme.errorColor}`) ||  `${Theme.mediumGray}`};
  font-size: 12px;
  line-height: 19px;
  margin-bottom: 8px;
  font-weight: 500;
`

export const InputStyle = styled(TextField)<InputStyleProps>`
  margin-bottom: 20px;
  &.MuiTextField-root {
    .MuiOutlinedInput-root {
      border-radius: 4px;
      .MuiInputBase-input {
        padding: 8px 12px;
        font-size: 16px;
      }
      .MuiOutlinedInput-notchedOutline {
        border-color: ${({invalid, disabled}) => `${(invalid && Theme.errorColor) || (disabled && Theme.ligthGray) || Theme.darkYellow}`};
      }
    }
  }
`

export const ErrorMessage = styled(Typography)<ErrorMessageProps>`
  color: ${`${Theme.errorColor}`};
  position: absolute;
  font-size: 12px;
  line-height: 16px;
  bottom: 0;
`;

export const FormControlS = styled(FormControl)`
  .MuiFormGroup-root{
    flex-direction: unset;
    .MuiRadio-root{
      color: ${Theme.darkYellow};
    }
    .Mui-checked{
      color: ${Theme.darkYellow};
    }
  }
`
